// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Mzm2E","tabsBox":"styles_tabsBox__egWRE","createButton":"styles_createButton__3id6j"};